import React, {FC} from "react";
import {IAuthAdminProps} from "../block-auth.type";
import AuthLoggedIn from "./auth-loggedIn";
import AuthForm from "./auth-form";

const AuthUser: FC<IAuthAdminProps> = (props: IAuthAdminProps) => {
  return !!props.login ? <AuthLoggedIn {...props} /> : <AuthForm {...props} />
};

export default AuthUser;
